// extracted by mini-css-extract-plugin
export var link = "_uo-0";